import { useEffect } from "react";
import { routes } from "../../routes";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../../services/cookies.service";

const NotFound = () => {
  const navigate = useNavigate();
  const token = getCookie("token");
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  useEffect(() => {
    if (!token && !isLoggedIn) {
      navigate(routes.HOME);
    }
  }, [token, isLoggedIn, navigate]);

  return (
    <div className="d-center flex-column vh-100">
      <h1 className="text-120px text-fw-800 text-golden-yellow">404</h1>
      <h2>Page Not Found</h2>
      <p className="text-muter-lavender-purple">
        Sorry, the page you are looking for doesn’t exist or has been moved.
      </p>

      <button
        onClick={() => navigate(routes.HOME)}
        className="w-10 w-md-100 filled-medium-deep-yellow-btn-dark"
      >
        Go to Home
      </button>
    </div>
  );
};

export default NotFound;
